import { graphql } from "@/graphql/codegen"

import "./entityLock.fragment"

graphql(`
  mutation AcquireEntityLock($input: EntityLockInput!) {
    entityLock {
      acquire(input: $input) {
        __typename
        ... on AcquireEntityLockSuccess {
          lock {
            ...EntityLockBaseFields
          }
        }
        ... on AcquireEntityLockFailure {
          error {
            message
            currentLock {
              ...EntityLockBaseFields
            }
          }
        }
      }
    }
  }
`)

graphql(`
  mutation HeartbeatEntityLock($input: EntityLockInput!) {
    entityLock {
      heartbeat(input: $input) {
        __typename
        ... on HeartbeatEntityLockSuccess {
          lock {
            ...EntityLockBaseFields
          }
        }
        ... on HeartbeatEntityLockFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation ReleaseEntityLock($input: EntityLockInput!) {
    entityLock {
      release(input: $input) {
        __typename
        ... on ReleaseEntityLockSuccess {
          released
        }
        ... on ReleaseEntityLockFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
